import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

import { LazyLoadDropdownItem } from "@sportal/cdk/dropdown/LazyLoadDropdownItem";
import { getDevicesForMerge } from "../../../store/devices/devices.selectors";
import { openMergeModal } from "../devices.actions";
import { Icon } from "../../icon/Icon";
import { DeviceActionsModalItem } from "../DeviceActionsDialog";

export const useMergeDeviceMenuItem = (deviceToMerge) => {
  const dispatch = useDispatch();
  const devicesForMerge = useSelector(
    getDevicesForMerge(deviceToMerge),
    _.isEqual
  );

  const isMergeDisabled = devicesForMerge.length === 0;

  return {
    id: "merge",
    content: (
      <Fragment>
        <Icon icon="fa-regular fa-link" />
        <span>
          <FormattedMessage id="merge_devices" />
        </span>
      </Fragment>
    ),
    disabled: isMergeDisabled,
    action: () => dispatch(openMergeModal(deviceToMerge, devicesForMerge)),
  };
};

export const MergeDeviceDropdownItem = ({ deviceToMerge, ...props }) => {
  const { id, content, disabled, action } =
    useMergeDeviceMenuItem(deviceToMerge);

  return (
    <LazyLoadDropdownItem
      id={id}
      disabled={disabled}
      action={action}
      {...props}
    >
      {content}
    </LazyLoadDropdownItem>
  );
};

export const MergeDeviceModalItem = ({ deviceToMerge }) => {
  const { id, content, disabled, action } =
    useMergeDeviceMenuItem(deviceToMerge);

  return (
    <DeviceActionsModalItem id={id} disabled={disabled} action={action}>
      {content}
    </DeviceActionsModalItem>
  );
};
